const USER_ROLE = {
  USER: "user",
  AGENT: "agent",
  ADMIN: "admin",
  SUPER_ADMIN: "superAdmin",
  INFLUENCER: "influencer",
};

export default USER_ROLE;
